import { InternalThemeDefinition } from "vuetify/lib/composables/theme";
import america from "./america";
import barra from "./barra";
import base from "./base";
import jec from "./jec";
import itajai from "./itajai";
import maracana from "./maracana";
import lnf from "./lnf";
import operario from "./operario";
import maracana_tour from "./maracana-tour";
import vitafor from "./vitafor";
import cbtm from "./cbtm";
import mva from "./mva";
import max from "./max";
import cluberun from "./cluberun";
import { resolveTheme } from "./tokens";

const rawThemes = { america, barra, base, jec, itajai, maracana, lnf, operario, maracana_tour, vitafor, cbtm, mva, max, cluberun };

export const themes = Object.fromEntries(
  Object.entries(rawThemes).map(([name, theme]) => [name, resolveTheme(theme)]),
) as Record<keyof typeof rawThemes, InternalThemeDefinition>;
